import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { formatApiError } from "@/context/AuthProvider";
import { useT } from "@/i18n";
import Logo from "@/components/common/Logo";
import ThemeToggle from "@/components/common/ThemeToggle";
import LanguageToggle from "@/components/common/LanguageToggle";

export default function ForgotPassword() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex items-center justify-between p-6">
        <Logo />
        <div className="flex items-center gap-2"><LanguageToggle /><ThemeToggle /></div>
      </div>
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <h1 className="font-display text-3xl font-extrabold tracking-tighter">{t("auth.forgotTitle")}</h1>
          <p className="mt-2 text-muted-foreground">{t("auth.forgotSubtitle")}</p>
          {sent ? (
            <div className="mt-8 rounded-md border border-border bg-secondary/50 p-4 text-sm" data-testid="reset-sent">
              {t("auth.resetSent")}
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <input
                data-testid="forgot-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")}
                className="h-11 w-full rounded-md border border-input bg-background px-3 text-sm outline-none transition-colors focus:ring-2 focus:ring-brand"
              />
              <button
                data-testid="forgot-submit" type="submit" disabled={loading}
                className="inline-flex h-11 w-full items-center justify-center rounded-md bg-primary font-medium text-primary-foreground transition-transform hover:opacity-90 active:scale-[0.98] disabled:opacity-60"
              >
                {loading ? t("common.loading") : t("auth.sendReset")}
              </button>
            </form>
          )}
          <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground" data-testid="back-to-login">
            <ArrowLeft className="h-4 w-4" /> {t("auth.backToLogin")}
          </Link>
        </div>
      </div>
    </div>
  );
}
